import {defineNuxtRouteMiddleware} from '#app';
import {safelyNavigateTo} from '@malt/utils';

export default defineNuxtRouteMiddleware(async (to, _from) => {
    if (to.params.city) {
        return await safelyNavigateTo(`/a/freelance/${to.params.city}`, {replace: true, externalToThisApp: true});
    }
});
